import {
  getApiUserManagementV1AccessReview,
  postApiUserManagementV1AccessReviewExport,
  type AccessReviewExportBody,
  type AccessReviewExportFormat
} from '@/libs/api-user-mgt/umOpenApiGaps/accessReviewNotInOpenApiClient';
import { mapAccessReviewListWire, type AccessReviewListWire } from '@/userManagement/application/mappers/accessReviewMapper';
import type { AccessReviewListParams } from '@/userManagement/application/types/AccessReviewListParams';
import { assertSpreadsheetBlob } from '@/userManagement/application/utils/readUmBlobErrorMessage';
import { parseFilenameFromContentDisposition } from '@/userManagement/application/utils/triggerBlobDownload';

export const userManagementAccessReviewSegment = {
  listAccessReview: async (params: AccessReviewListParams) => {
    const response = await getApiUserManagementV1AccessReview({
      page: params.page,
      pageSize: params.pageSize,
      deviantsOnly: params.deviantsOnly,
      databaseName: params.databaseName,
      permissionSnapshotId: params.permissionSnapshotId,
      dateFrom: params.dateFrom,
      dateTo: params.dateTo
    });
    return mapAccessReviewListWire((response.data ?? {}) as AccessReviewListWire);
  },

  exportAccessReview: async (
    body: AccessReviewExportBody,
    format: AccessReviewExportFormat = 'xlsx'
  ): Promise<{ blob: Blob; filename: string }> => {
    const response = await postApiUserManagementV1AccessReviewExport(body, format);
    const extension = format === 'xlsx' ? 'xlsx' : 'csv';
    const fallback = `access-review-${new Date().toISOString().slice(0, 10)}.${extension}`;
    const disposition =
      typeof response.headers === 'object' && response.headers != null && 'content-disposition' in response.headers
        ? String(response.headers['content-disposition'])
        : undefined;

    const blob = response.data;
    await assertSpreadsheetBlob(blob, fallback);
    return {
      blob,
      filename: parseFilenameFromContentDisposition(disposition) ?? fallback
    };
  }
};
